import { DisabledOptionInfo, Dropdown } from 'components/dropdown/Dropdown';
import { NoValue } from 'components/no_value/NoValue';
import { OptionChild } from 'utils/node';

// Fixed width stops the popup collapsing to the trigger width and wrapping items.
const DEFAULT_WIDTH = '12rem';

type NumericOptionDropdownProps = Readonly<{
    value: number;
    options: OptionChild<number>[];
    onChange: (next: number) => void;
    width?: string;
    disabled?: boolean;
    disabledOptions?: DisabledOptionInfo[];
}>;

export function NumericOptionDropdown({
    value,
    options,
    onChange,
    width = DEFAULT_WIDTH,
    disabled = false,
    disabledOptions,
}: NumericOptionDropdownProps) {
    const selected = options.find((o) => o.Value === value);
    return (
        <Dropdown<OptionChild<number>>
            value={selected}
            data={options}
            onChange={(opt) => onChange(opt.Value)}
            renderLabel={({ value: opt }) => opt?.Text ?? <NoValue />}
            renderItem={({ item }) => item.Text}
            dataKey={(item) => item.Value}
            isDisabled={disabled}
            disabledItems={disabledOptions}
            trigger={{ paddingOverride: 'none', style: { width } }}
            popup={{ width }}
        />
    );
}
